import colors from 'vuetify/es5/util/colors'
var themes = {
  light: {
    primary: '#1f337d',
    secondary: '#F4F4F5',
    textFooter: '#1f337d',
    accent: colors.blue.accent1,
    error: colors.red.accent2,
    info: colors.blue,
    success: colors.green,
    warning: colors.amber
  },
  dark: {
    primary: colors.blue.darken2,
    secondary: colors.grey.lighten2,
    accent: colors.blue.accent1,
    error: colors.red.accent2,
    info: colors.blue,
    success: colors.green,
    warning: colors.amber
  }
}

switch (window.env.VUE_APP_AMBIENTE) {
  case 'acg':
    themes = {
      light: {
        primary: '#4C3B5F',
        secondary: '#EEE5E6',
        textFooter: '#EEE5E6',
        accent: colors.blue.accent1,
        error: colors.red.accent2,
        info: colors.blue,
        success: colors.green,
        warning: colors.amber
      }
    }
    break
}

let background = '/assets/imgs/background.svg'
let logo = '/assets/imgs/logo.svg'

try {
  if (localStorage.ambiente) {
    require('@/assets/imgs/' + localStorage.ambiente + '/background.svg')
    background = '/assets/imgs/' + localStorage.ambiente + '/background.svg'
  }
} catch { }
try {
  if (localStorage.ambiente) {
    require('@/assets/imgs/' + localStorage.ambiente + '/logo-inverted.svg')
    logo = '/assets/imgs/' + localStorage.ambiente + '/logo-inverted.svg'

    var favicon = document.getElementById('custom-favicon')
    favicon.setAttribute('href', '/assets/imgs/' + localStorage.ambiente + '/favicon.svg')
  }
} catch { }

var headerColor = themes.light.primary
var backgroundHome = null
var footerColor = themes.light.primary
var headerTextDark = false

switch (window.env.VUE_APP_AMBIENTE) {
  case 'acg':
    backgroundHome = 'assets/imgs/acg/background-home.svg'
    headerTextDark = true
    break;
  case 'recebiveisbmp':
    headerColor = themes.light.secondary
    footerColor = themes.light.secondary
    logo = '/assets/imgs/recebiveisbmp/logo.svg'
    break;
}

export default {
  dark: false,
  options: {
    customProperties: true,
    dense: false,
    sliderIcon: {
      color: '#F4F4F5'
    },
    toolbar: { color: headerColor, dark: headerTextDark },
    footer: { color: footerColor },
    backgroundHome
  },
  background,
  logo,
  themes: themes
}
